export const FONT_WEIGHT = {
    regular: 400,
    medium: 500,
    semibold: 600, // @fixme
}
